module.exports = __webpack_public_path__ + "img/gain-item4.f3df005a.png";